import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { useRootStore } from '../hooks/useRootStore';
import { ScheduleTemplate } from '../data/ScheduleTemplate';
import { WeekDayRusShort } from '../data/WeekDay';
import './Schedule.css'

export interface NewActivityData {
    comment: string,
    timeStart: Date,
    timeEnd: Date,
}

export default function ChangeScheduleTemplateDialog({ onSave, onCancel }: { onSave: () => void, onCancel: () => void }) {
    const { api } = useRootStore();

    const [loading, setLoading] = useState(true);
    const [template, setTemplate] = useState([] as ScheduleTemplate[]);

    useEffect(() => {
        api.getScheduleTemplate().then(e => {
            setTemplate(e.sort((a, b) => (a.weekDay == 0 ? 7 : a.weekDay) - (b.weekDay == 0 ? 7 : b.weekDay)));
            setLoading(false);
        });

    }, [api]);

    const handleHourClick = async (dayIndex: number, hourIndex: number) => {
        const newTemplate = template.slice();
        newTemplate[dayIndex].hours[hourIndex] = !newTemplate[dayIndex].hours[hourIndex];
        setTemplate(newTemplate);
    }

    const saveTemplate = () => {
        api.updateScheduleTemplate(template);
        onSave();
    }

    return (
        <Box>
            <Dialog open={true} onClose={onCancel} maxWidth="lg">
                <DialogTitle>Изменение шаблона расписания</DialogTitle>
                <DialogContent>
                    {loading ? <CircularProgress /> :
                        <Box className='schedule' sx={{width:900}}>
                            {template.map(d =>
                                <Box className={'working-day day-' + (d.weekDay)} key={d.weekDay}>
                                    <span className='week-day'>{WeekDayRusShort[d.weekDay]}</span>
                                    {d.hours.map((h, hi) =>
                                        <span key={hi} className={"working-hour" + (h ? ' work' : '')} onClick={() => handleHourClick((d.weekDay == 0 ? 7 : d.weekDay)-1, hi)}>
                                            {hi}
                                        </span>
                                    )}
                                </Box>
                            )}
                        </Box>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCancel}>Отмена</Button>
                    <Button onClick={saveTemplate}>Сохранить</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}